module.exports = __webpack_public_path__ + "img/sign.ae2df8fd.png";